<template>
  <transition name="slide">
    <div
      class="message-wrap"
      :style="{ borderColor: type === 'success' ? '#86c43d' : '#c00' }"
      v-if="visible"
    >
      <div class="message-content">
        <div :class="type === 'success' ? 'success_icon' : 'error_icon'"></div>
        {{ content }}
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "Message",
  data() {
    return {
      visible: false,
      type: "success",
      content: "",
      duration: 3000,
    };
  },
  computed: {},
  methods: {
    startTimer() {
      window.setTimeout(() => {
        this.visible = false;
      }, this.duration);
    },
  },
  mounted() {
    this.startTimer();
  },
};
</script>
<style scoped lang="scss">
.message-wrap {
  position: fixed;
  background-color: #fff;
  font-size: 14px;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  .message-content {
    line-height: 40px;
    padding: 20px 55px;
    display: flex;
    align-items: center;
    .error_icon {
      height: 46px;
      width: 14px;
      margin: 0 14px 0 0;
      background: url(~@/assets/common/message/search-icons.png) no-repeat;
    }
    .success_icon {
      height: 48px;
      width: 48px;
      margin: 0 14px 0 0;
      background: url(~@/assets/common/message/success-icons.png) no-repeat;
    }
  }
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.2s;
}
.slide-enter,
.slide-leave-to {
  transform: translate(-50%, -50%) scale(0);
}
</style>